import {
  GET_MAIN_SLIDER_V2_REQUEST,
  GET_MAIN_SLIDER_V2_SUCCESS,
  GET_MAIN_SLIDER_V2_FAILURE,
  MAIN_SLIDER_ODDS_WS_V2_UPDATE,
  MAIN_SLIDER_EVENT_REMOVED_WS_V2,
  MAIN_SLIDER_EVENT_ADDED_WS_V2,

  GET_HOME_CAMPAIGN_REQUEST,
  GET_HOME_CAMPAIGN_SUCCESS,
  GET_HOME_CAMPAIGN_FAILURE,

  GET_HOME_SUB_HEADER_REQUEST,
  GET_HOME_SUB_HEADER_SUCCESS,
  GET_HOME_SUB_HEADER_FAILURE,
  GET_HOME_PAGE_GAME_LIST_REQUEST,
  GET_HOME_PAGE_GAME_LIST_SUCCESS,
  GET_HOME_PAGE_GAME_LIST_FAILURE
} from 'Store/constants';

const initialState = {
  mainSliderV2: {
    data: [],
    isLoading: false,
    error: null,
  },
  campaign: {
    data: [],
    isLoading: false,
    error: null
  },
  subHeader: {
    data: [],
    isLoading: false,
    error: null
  },
  gameListData: {
    data: [],
    isLoading: false,
    error: null
  }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_MAIN_SLIDER_V2_REQUEST:
      return { ...state, mainSliderV2: { ...state.mainSliderV2, isLoading: true, error: null } };
    case GET_MAIN_SLIDER_V2_SUCCESS:
      return { ...state, mainSliderV2: { data: action.payload, isLoading: false, error: null } };
    case GET_MAIN_SLIDER_V2_FAILURE:
      return { ...state, mainSliderV2: { ...state.mainSliderV2, isLoading: false, error: action.payload } };

    case MAIN_SLIDER_ODDS_WS_V2_UPDATE:
    case MAIN_SLIDER_EVENT_REMOVED_WS_V2:
    case MAIN_SLIDER_EVENT_ADDED_WS_V2: {
      return {
        ...state,
        mainSliderV2: {
          ...state.mainSliderV2,
          data: state.mainSliderV2?.data?.map(item => {
            if (!item.event || item.event.id !== action.payload?.eventId) {
              return item;
            }

            return {
              ...item,
              event: {
                ...item.event,
                ...action.payload?.event
              },
              marketGroups: action.payload?.marketGroups || item.marketGroups,
              markets: action.payload?.markets || {}
            };
          })
        }
      };
    }

    case GET_HOME_CAMPAIGN_REQUEST:
      return { ...state, campaign: { ...state.campaign, isLoading: true, error: null } };
    case GET_HOME_CAMPAIGN_SUCCESS:
      return { ...state, campaign: { data: action.payload, isLoading: false, error: null } };
    case GET_HOME_CAMPAIGN_FAILURE:
      return { ...state, campaign: { ...state.campaign, isLoading: false, error: action.payload } };

    case GET_HOME_SUB_HEADER_REQUEST:
      return { ...state, subHeader: { ...state.subHeader, isLoading: true, error: null } };
    case GET_HOME_SUB_HEADER_SUCCESS:
      return { ...state, subHeader: { data: action.payload, isLoading: false, error: null } };
    case GET_HOME_SUB_HEADER_FAILURE:
      return { ...state, subHeader: { ...state.subHeader, isLoading: false, error: action.payload } };

    case GET_HOME_PAGE_GAME_LIST_REQUEST:
      return { ...state, gameListData: { ...state.gameListData, isLoading: true, error: null } };
    case GET_HOME_PAGE_GAME_LIST_SUCCESS:
      return { ...state, gameListData: { data: action.payload, isLoading: false, error: null } };
    case GET_HOME_PAGE_GAME_LIST_FAILURE:
      return { ...state, gameListData: { ...state.gameListData, isLoading: false, error: action.payload } };

    default:
      return state;
  }
};
